import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import EditNoteIcon from "@mui/icons-material/EditNote";
import RedeemIcon from "@mui/icons-material/Redeem";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Form, Modal, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import { Info } from "lucide-react";


import profile_icon from "../../assets/img/profile_icon.png";
import {
  clearBookingData,
  fetchbooknAsync,
} from "../../store/apiSlice/BooknannySlice";
import { calculateBooking, getSpecialDayChargePercentage, getTravelInfo, isSpecialDate as isSpecialDateCheck } from "../../utils/help";
import { extraChildrenAddPrice, travellingCostFixed, travellingCostTime } from "../../utils/Constants";
import { clearTravellInfoData, getTravellInfo } from "../../store/apiSlice/getTravellInfoSlice";


const Bookdetails = () => {
  const location = useLocation();
  const {
    address,
    date,
    time,
    counter,
    divs,
    latitude,
    longitude,
    categoryId,
    profileImage,
    price,
    firstName,
    lastName,
    nannyId,
    categoriesDetail,
    basePrice,
    isSpecialDate,
    street,
    appartment,
    house,
    userAddress,
    nammylatitude,
    nammylongitude,
    summary
  } = location.state;

  const navigate = useNavigate();

  const bookingData = useSelector(
    (state) => state.rootReducer.bookNannyData.data
  );
  const bookingTravellData = useSelector(
    (state) => state.rootReducer.getTravellInfo.data
  );
  const [show, setShow] = useState(false);
  const [discount, setDiscount] = useState(0);

  const [userLat, setUserLat] = useState(null);
  const [userLang, setUserLang] = useState(null);

  const handleCloses = () => setShow(false);
  const handleShows = () => setShow(true);

  const dispatch = useDispatch();

  const [midnightTaxyFee, setMidnightTaxyFee] = useState(0);
  const [endTime, setEndTime] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [total, setTotal] = useState(0);
  const [subtotalBeforeIVA, setSubtotalBeforeIVA] = useState(0);
  const [ivaAmount, setIvaAmount] = useState(0);
  const [travellFee, setTravellFee] = useState(0);

  const IVA_RATE = 0.21;

  const [travellObj, setTravellObj] = useState(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported")
      return
    };
    navigator.geolocation.getCurrentPosition(
      async ({ coords }) => {
        setUserLat(coords.latitude);
        setUserLang(coords.longitude);
      },
      (err) => {
        alert("Geolocation not supported")
        return
      }
    );
  }, []);


  useEffect(() => {
    const fetchTravelInfo = async () => {
      if (latitude && longitude && nammylatitude && nammylongitude) {
        dispatch(getTravellInfo({ originLat: latitude, originLng: longitude, destLat: Number(nammylatitude), destLng: Number(nammylongitude) }))
      }
    };

    fetchTravelInfo();
  }, [latitude, longitude, nammylatitude, nammylongitude]);


  useEffect(() => {
    let base = basePrice;
    if (divs.length > 2) {
      base = base + ((divs.length - 2) * extraChildrenAddPrice);
    }
    let specialDateChargePercentage = 1
    if (date) {
      specialDateChargePercentage = getSpecialDayChargePercentage(date)
      base = isSpecialDateCheck(date, base)
    }

    let taxiFee = 0;
    if (time) {
      setStartTime(time)
      const { taxiFee: fee, endTime } = calculateBooking(time, counter);
      setEndTime(endTime)
      taxiFee = fee * specialDateChargePercentage;
      setMidnightTaxyFee(taxiFee)
    }
    base = (base * counter) + (taxiFee || 0)

    let travellingFee = 0
    if (travellObj && Object.keys(travellObj).length !== 0 && travellObj.durationMinutes && travellObj.durationMinutes > 30) {
      // console.log("1111111111111111: ", travellObj.durationMinutes / 60)
      travellingFee = parseFloat(basePrice * (travellObj.durationMinutes / 60) + travellingCostFixed)
      // travellingFee = basePrice * Math.floor(travellObj.durationMinutes / travellingCostTime) + travellingCostFixed
      setTravellFee(travellingFee)
    }
    base = base + travellingFee
    const preIVA = parseFloat((base - discount).toFixed(2));
    const iva = parseFloat((preIVA * IVA_RATE).toFixed(2));
    setSubtotalBeforeIVA(preIVA);
    setIvaAmount(iva);
    setTotal(parseFloat((preIVA + iva).toFixed(2)));


  }, [basePrice, discount, travellObj]);

  const handlebook = () => {
    const payload = {
      nannyId: nannyId,
      categoryId: categoryId,
      date: date,
      time: time || null,
      numberOfHours: counter,
      childrenDetails: divs,
      price: total,
      discount: discount || 0,
      address: userAddress,
      latitude: latitude,
      longitude: longitude,
      saveForFuture: 0,
      finalPrice: total - discount,
      street,
      appartment,
      house,
      summary
    };

    try {
      dispatch(fetchbooknAsync(payload));
    } catch (error) {
      console.error("signup failed:", error);
    }
  };

  useEffect(() => {
    if (bookingTravellData != null && bookingTravellData.status === 1) {
      setTravellObj(bookingTravellData.data)
    }
  }, [bookingTravellData]);


  useEffect(() => {
    if (bookingData != null && bookingData.status === 1) {
      // navigate("/StipePayment", {
      //   state: {
      //     address,
      //     date,
      //     time,
      //     counter,
      //     divs,
      //     latitude,
      //     longitude,
      //     categoryId,
      //     profileImage,
      //     price: total - discount,
      //     firstName,
      //     lastName,
      //     nannyId,
      //     basePrice,
      //     bookingId: bookingData?.data._id,
      //     orderId: bookingData?.data.orderId
      //   },
      // });
      navigate("/payment-options", {
        state: {
          address,
          date,
          time,
          counter,
          divs,
          latitude,
          longitude,
          categoryId,
          profileImage,
          price: total,
          firstName,
          lastName,
          nannyId,
          basePrice,
          bookingId: bookingData?.data._id,
          orderId: bookingData?.data.orderId
        },
      });
    }
  }, [bookingData]);


  useEffect(() => {
    return () => {
      dispatch(clearBookingData());
    };
  }, []);

  const additionalHours = Math.max(counter - 1, 0);
  const extraChildren = Math.max(divs.length - 2, 0);
  const hourlyRate = basePrice;
  const extraHourFee = additionalHours * hourlyRate;
  const extraChildrenFee = extraChildren * extraChildrenAddPrice * counter;

  return (
    <>
      <div className="book_detailsmain">
        <div className="book_details">
          <form>
            <div className="book_title">
              <div className="heading">
                <h4>{categoriesDetail.name}</h4>
                {/* <p>
                  <span>08 Aug</span> - <span>04:00PM</span>
                </p> */}
              </div>
              <div className="extendbooking">
                {/* <Link to="#"> */}
                {/* <EditNoteIcon /> Extend Booking */}
                {/* </Link> */}
              </div>
            </div>
            <div className="description">
              <p>DESCRIPTION</p>
            </div>
            <div className="nanny_info">
              <div className="nanny_img">
                <img
                  src={profileImage !== "" ? profileImage : profile_icon}
                  alt="nanny"
                />
                <h5>
                  {firstName} {lastName}
                </h5>
              </div>
              <h5>€{((basePrice * (getSpecialDayChargePercentage(date) || 1)) * 1.21).toFixed(2)}/hr</h5>
            </div>

            <div className="booking_info">
              <div className="boking_sec">
                <h5>
                  Booking Date
                </h5>
                <h5>{date}</h5>
              </div>

              {startTime && endTime && <div className="boking_sec">
                <h5>
                  Time
                </h5>
                <h5>{startTime} - {endTime}</h5>
              </div>}

              <div className="boking_sec">
                <h5>
                  Total Hours
                </h5>
                <h5>{counter}</h5>
              </div>



              {divs && divs?.length && <div className="boking_sec">
                <h5>
                  Total Children
                </h5>
                <h5>{divs?.length}</h5>
              </div>}

              {/* {travellObj && Object.keys(travellObj).length !== 0 && travellObj.durationMinutes && travellObj.durationMinutes > 30 && <div className="boking_sec">
                <h5>
                  Travelling Distance
                </h5>
                <h5>{Math.floor(travellObj.distanceKm)} <span style={{ fontSize: "14px" }}>(km)</span></h5>
              </div>} */}

              {/* {travellObj && Object.keys(travellObj).length !== 0 && travellObj.durationMinutes && travellObj.durationMinutes > 30 && <div className="boking_sec">
                <h5>
                  Travelling Time
                </h5>
                <h5>{Math.floor(travellObj.durationMinutes)} <span style={{ fontSize: "14px" }}>(min)</span></h5>
              </div>} */}

            </div>

            {/* <div className="redeem-icon">
              <h6>
                <span>
                  <RedeemIcon />
                </span>{" "}
                Redeem promotion
              </h6>
              <div className="modal_btn">
                <p onClick={handleShows}>
                  <ChevronRightIcon />
                </p>
              </div>
            </div> */}

            <div className="price_details">
              <ul>
                <div className="fee_price">
                  <ul>
                    <li>{`Total Hours (${counter} hrs, up to ${divs?.length || 0} childrens)`}</li>
                  </ul>
                  <p>€{(
                    (basePrice * (getSpecialDayChargePercentage(date) || 1)) +
                    (extraHourFee * (getSpecialDayChargePercentage(date) || 1)) +
                    ((extraChildrenFee || 0) * (getSpecialDayChargePercentage(date) || 1))

                  ).toFixed(2)}</p>
                </div>

                {/* {additionalHours > 0 && (
                  <div className="fee_price">
                    <ul>
                      <li>Additional Hours ({additionalHours} hrs @ €{(basePrice * (getSpecialDayChargePercentage(date) || 1)).toFixed(2)}/hr)</li>
                    </ul>
                    <p>€{(extraHourFee * (getSpecialDayChargePercentage(date) || 1)).toFixed(2)}</p>
                  </div>
                )} */}

                {/* {extraChildren > 0 && (
                  <div className="fee_price">
                    <ul>
                      <li>Extra Children Fee ({extraChildren} children × €4.00 × {counter} hrs)</li>
                    </ul>
                    <p>€{(extraChildrenFee * (getSpecialDayChargePercentage(date) || 1)).toFixed(2)}</p>
                  </div>
                )} */}

                {/* <div className="fee_price">
                  <ul>
                    <li>Sub Total</li>
                  </ul>
                  <p>€{
                    (Number(basePrice) +
                      (additionalHours ? Number(extraHourFee.toFixed(2)) : 0) +
                      (extraChildren ? Number(extraChildrenFee.toFixed(2)) : 0)).toFixed(2)
                  }
                  </p>
                </div> */}
              </ul>

              <ul
              // style={{ marginTop: "1rem" }}
              >

                {/* <div className="fee_price">
                  <ul>
                    <li style={{ color: "#007b8f", fontWeight: 600 }}>Conditional Charges: </li>
                  </ul>
                </div> */}

                {/* {isSpecialDate && (
                  <div className="fee_price">
                    <ul>
                      <li>Special Date Surcharge ({getSpecialDayChargePercentage(date) * 100}% of Sub Total)</li>
                    </ul>
                    <p>€
                      {
                        ((Number(basePrice) +
                          (additionalHours ? Number(extraHourFee.toFixed(2)) : 0) +
                          (extraChildren ? Number(extraChildrenFee.toFixed(2)) : 0)) * getSpecialDayChargePercentage(date)).toFixed(2)
                      }
                    </p>
                  </div>
                )} */}

                {midnightTaxyFee > 0 && (
                  <div className="fee_price">
                    <ul>
                      <li>Midnight Taxi Fee</li>
                    </ul>
                    <p>€{midnightTaxyFee.toFixed(2)}</p>
                  </div>
                )}

                {
                  travellObj &&
                  Object.keys(travellObj).length !== 0 &&
                  travellObj.durationMinutes &&
                  travellObj.durationMinutes > 30 && (
                    <div className="fee_price flex items-center gap-2">
                      <ul >
                        <li style={{ display: "flex", gap: "5px" }} className="font-semibold">Travelling Fee<span
                          data-tooltip-id="travelling-fee-tooltip"
                          className="cursor-pointer text-blue-600 hover:text-blue-800 flex items-center"
                        >
                          <Info size={12} />
                        </span></li>

                      </ul>

                      <p className="text-lg font-bold text-gray-800">
                        €{travellFee.toFixed(2)}
                      </p>



                      <Tooltip
                        id="travelling-fee-tooltip"
                        place="top"
                        className="!bg-gray-900 !text-white !text-sm !rounded-lg !px-3 !py-2 !shadow-lg max-w-xs text-center"
                      >
                        {`Total Travel Time (${travellObj.durationMinutes} min)  ÷ (60 min) × Hourly Fee (€${basePrice.toFixed(2)})  + Fixed Transport Fee (€${travellingCostFixed.toFixed(2)})`}
                        {/* {`Total Travel Time (${travellObj.durationMinutes} min)  ÷ (${travellingCostTime} min) × Hourly Fee (€${basePrice.toFixed(2)})  + Fixed Transport Fee (€${travellingCostFixed.toFixed(2)})`} */}
                      </Tooltip>
                    </div>
                  )
                }


                {/* {travellObj && Object.keys(travellObj).length !== 0 && travellObj.durationMinutes && travellObj.durationMinutes > 30 && (
                  <div className="fee_price">
                    <ul>
                      <li>More than 30 min travelling Fee</li>
                    </ul>
                    <p>€
                      {
                        travellingCostFixed
                      }
                    </p>
                  </div>
                )} */}


                {/* <div className="fee_price">
                  <ul>
                    <li>Discount</li>
                  </ul>
                  <p>€{discount.toFixed(2)}</p>
                </div> */}

                <div className="fee_price">
                  <ul>
                    <li>Subtotal (excl. IVA)</li>
                  </ul>
                  <p>€{subtotalBeforeIVA.toFixed(2)}</p>
                </div>

                <div className="fee_price">
                  <ul>
                    <li>IVA (21%)</li>
                  </ul>
                  <p>€{ivaAmount.toFixed(2)}</p>
                </div>


              </ul>
            </div>

            <div className="total_price">
              <h4>Total</h4>
              <h4>€{total.toFixed(2)}</h4>
            </div>
            <div className="booking_btn">
              {/* <CardElement /> */}
              <button
                type="button"
                className="btn_continue"
                onClick={() => handlebook()}
              >
                Confirm
              </button>
            </div>
          </form>
        </div>
      </div>
      <Modal show={show} onHide={handleCloses} className="redeem_modal mt-5">
        <Modal.Header closeButton>
          <Modal.Title>Redeem Promotion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="book_detailsmain">
            <div className="book_details mt-0">
              <Form className="redeem_form">
                <InputGroup className="mb-3">
                  <Form.Control placeholder="Enter Promo Code" />
                  <InputGroup.Text>
                    <p>Redeem</p>
                  </InputGroup.Text>
                </InputGroup>
              </Form>
              <div className="redeem_cards">
                <div className="heading">
                  <h6>AVAILABE COUPONS</h6>
                </div>
                <div className="card">
                  <div className="card_body">
                    <div className="card_heading">
                      <h5>Naturebreed</h5>
                      <p onClick={handleCloses} style={{ color: "#89d6ce" }}>
                        Apply
                      </p>
                    </div>
                    <div className="get_off">
                      <span>Get 50% off</span>
                    </div>
                    <div className="off_all">
                      <p>50% Off on all service</p>
                    </div>
                  </div>
                  <div className="card_end">
                    <p>
                      Offer valid <span>Today,till 05:00 pm</span>
                    </p>
                  </div>
                </div>
                <div className="card">
                  <div className="card_body">
                    <div className="card_heading">
                      <h5>Naturebreed</h5>
                      <Link
                        to="#"
                        onClick={handleCloses}
                        style={{ color: "#89d6ce" }}
                      >
                        Apply
                      </Link>
                    </div>
                    <div className="get_off">
                      <span>Get 50% off</span>
                    </div>
                    <div className="off_all">
                      <p>50% Off on all service</p>
                    </div>
                  </div>
                  <div className="card_end">
                    <p>
                      Offer valid <span>Today,till 05:00 pm</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Bookdetails;
